<div class="main-Content d-flex">
  <h3>Create New {{ isCustomerSelected ? "Customer" : "User" }}</h3>
  <div
    class="container-fluid d-flex flex-column mat-table elevation flex-2 px-5 py-5"
  >
    <form [formGroup]="formModel" autocomplete="off">
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="col-sm-4" *ngIf="isAdminUser" style="margin-top: 15px">
            <label>Role<span style="color: #ff232382">*</span></label>
            <select
              class="form-control"
              formControlName="Role"
              autocomplete="off"
              (change)="onRoleChange()"
            >
              <option value="Admin">Admin</option>
              <option value="CSP">CSP</option>
              <option value="Customer">Customer</option>
            </select>
          </div>
          <div
            class="col-sm-8"
            *ngIf="isCustomerSelected"
            style="margin-top: 15px"
          >
            <label>Company Name<span style="color: #ff232382">*</span></label>
            <input
              class="form-control"
              #Company="ngModel"
              [(ngModel)]="CompanyName"
              name="CompanyName"
              [ngModelOptions]="{ standalone: true }"
              autocomplete="off"
            />
            <label class="text-danger" *ngIf="isCompanyRequired && submitted"
              >Company Name is required.</label
            >
          </div>
          <div class="col-sm-4" style="margin-top: 15px">
            <label>First Name</label>
            <input
              class="form-control"
              formControlName="FirstName"
              autocomplete="off"
            />
            <label
              class="text-danger"
              *ngIf="formModel.get('FirstName').errors?.required && submitted"
              >First Name is required.</label
            >
          </div>
          <div class="col-sm-4" style="margin-top: 15px">
            <label>Last Name</label>
            <input
              class="form-control"
              formControlName="LastName"
              autocomplete="off"
            />
            <label
              class="text-danger"
              *ngIf="formModel.get('LastName').errors?.required && submitted"
              >Last Name is required.</label
            >
          </div>

          <div class="col-sm-4" style="margin-top: 15px">
            <label>Mobile</label>
            <input class="form-control" formControlName="Mobile" />
            <label
              class="text-danger"
              *ngIf="formModel.get('Mobile').errors?.required && submitted"
              >Mobile number is required.</label
            >
            <label
              class="text-danger"
              *ngIf="
                formModel.get('Mobile').touched &&
                formModel.get('Mobile').errors?.pattern
              "
              >Please enter 10 digit mobile number.</label
            >
          </div>

          <div class="col-sm-4" style="margin-top: 15px">
            <label>Email<span style="color: #ff232382">*</span></label>
            <input class="form-control" formControlName="Email" />
            <label
              class="text-danger"
              *ngIf="formModel.get('Email').errors?.required && submitted"
              >Email Address is required.</label
            >
            <label
              class="text-danger"
              *ngIf="
                formModel.get('Email').touched &&
                formModel.get('Email').errors?.email
              "
              >Please enter valid email address.</label
            >
          </div>
          <!-- New Field for PartnerCenterId -->
          <div
            class="col-sm-4"
            *ngIf="isCustomerSelected"
            style="margin-top: 15px"
          >
            <label
              >Partner Center ID<span style="color: #ff232382">*</span></label
            >
            <input
              class="form-control"
              formControlName="PartnerCenterId"
              autocomplete="off"
            />
            <label
              class="text-danger"
              *ngIf="
                formModel.get('PartnerCenterId').errors?.required && submitted
              "
              >Partner Center ID is required.</label
            >
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <div class="col-sm-4" style="margin-top: 10px">
            <label>Username<span style="color: #ff232382">*</span></label>
            <input
              class="form-control"
              formControlName="UserName"
              minlength="6"
            />
            <label
              class="text-danger"
              *ngIf="formModel.get('UserName').errors?.required && submitted"
              >UserName is required.</label
            >
            <label class="text-danger" *ngIf="formModel.get('UserName').value.length<6 && submitted">Username should be more than 5 characters</label>
          </div>
          <div formGroupName="Passwords">
            <div class="col-sm-4" style="margin-top: 10px">
              <label>Password<span style="color: #ff232382">*</span></label>
              <input
                [type]="fieldTextType ? 'text' : 'password'"
                class="form-control"
                formControlName="Password"
                autocomplete="off"
              />
              <label
                class="text-danger"
                *ngIf="
                  formModel.get('Passwords.Password').touched &&
                  formModel.get('Passwords.Password').errors?.required
                "
                >Password is required</label
              >
              <label
                class="text-danger"
                *ngIf="
                  formModel.get('Passwords.Password').touched &&
                  formModel.get('Passwords.Password').errors?.minlength
                "
                >Minimum 4 characters required.</label
              >
            </div>
            <div class="col-sm-4" style="margin-top: 10px">
              <label>Confirm Password</label>
              <input
                [type]="fieldTextType ? 'text' : 'password'"
                class="form-control"
                formControlName="ConfirmPassword"
                autocomplete="off"
              />
              <label
                class="text-danger"
                *ngIf="
                  formModel.get('Passwords.ConfirmPassword').touched &&
                  formModel.get('Passwords.ConfirmPassword').errors?.required
                "
                >Confirm Password is requird.</label
              >
              <label
                class="text-danger"
                *ngIf="
                  formModel.get('Passwords.ConfirmPassword').touched &&
                  formModel.get('Passwords.ConfirmPassword').errors
                    ?.passwordMismatch
                "
                >Confirm Password does not match.</label
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12 mt-3 ml-3">
          <div class="text-center">
            <button (click)="onClose()" class="btn btn-close">Close</button
            >&nbsp;&nbsp;&nbsp;
            <button (click)="onSubmit()" class="btn btn-ok">
              <span
                *ngIf="loading"
                style="border-width: 0.1em"
                class="spinner-border spinner-border-sm mr-2"
              ></span>
              Create New {{ isCustomerSelected ? "Customer" : "User" }}</button
            >&nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
